/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class TermsAndConditionsAgreementDtoModel extends JSONable {
  userUuid: string | undefined = undefined;
  email: string | undefined = undefined;
  termsAndConditionsDocumentVersion: string | undefined = undefined;
  termsAndConditionsDocumentLanguage: string | undefined = undefined;
  validFrom: Date | undefined = undefined;
  validTo: Date | undefined = undefined;
}
